module.exports = __webpack_public_path__ + "static/img/PE@2x.48d39e27.jpg";